<template lang="pug">

.page.page_offset_top.page_offset_bottom
  .page-meta.page-meta_rates
    .container
      .page-meta__inner
        breadcrumbs
        .rates-cities
          router-link(to="/rates").rates-cities__link.is-active Москва
          router-link(to="/rates").rates-cities__link Сочи

  tabs(type="rates-tabs")
    tab(v-for="tab, index in tabs" :name="tab.name" :key="index" :selected="index == 0")
      .rates
        .rates-mob
          h2.rates-mob__title Mercedes-Benz СLA и Mercedes-Benz GLA
          p.rates-mob__desc Передвигайтесь по городу на автомобиле премиум-класса, сочетающем комфорт, стиль и легкость управления.
        .rates__left
          slick(ref="slick" :options="slickOptionsMain").rates-slider
            .rates-slider__item(v-for="item, n in 4")
              img(src="/static/img/car.png" alt="").rates-slider__img

          slick(ref="slick" :options="slickOptionsNav").rates-slider-nav
            .rates-slider-nav__item(v-for="item, n in 4")
              img.rates-slider-nav__img(src="/static/img/car-thumb@2x.png" alt="")
        .rates__right
          .rates__content
            h2.rates__title.title.title_size_m Mercedes-Benz СLA и Mercedes-Benz GLA
            p.rates__desc Передвигайтесь по городу на автомобиле премиум-класса, сочетающем комфорт, стиль и легкость управления.
          .rates-table
            rates-table-row(v-for="row, index in rows", :title="row.title" :value="row.value" :symbol="row.symbol" :extraValue="switchState ? row.extraValue : ''" :time="row.time" :switcher="row.switcher" @changeState="stateChanged" :key="index")

</template>

<script>
import Slick from 'vue-slick'
import RatesTableRow from './../components/rates-table-row.vue'
import Tabs from './../components/tabs.vue'
import Tab from './../components/tab.vue'

export default {
  props: [],
  components: {
    Tabs,
    Tab,
    Slick,
    RatesTableRow
  },
  data () {
    return {
      rows: [
        {
          title: 'бронирование',
          value: '0',
          time: '20 минут',
          symbol: '₽'
        },
        {
          title: 'осмотр',
          value: '0',
          time: '7 минут',
          symbol: '₽'
        },
        {
          title: 'поездка',
          value: '11',
          extraValue: '+2',
          time: 'в минуту',
          symbol: '₽'
        },
        {
          title: 'ожидание',
          value: '2',
          time: 'в минуту',
          symbol: '₽'
        },
        {
          title: 'ночное ожидание',
          value: '0',
          time: 'с 0.00 до 6.00',
          symbol: '₽'
        },
        {
          title: 'максимум в сутки',
          value: '2 000',
          extraValue: '+1000 ',
          time: 'в сутки',
          symbol: '₽'
        },
        {
          title: 'лимит в километрах',
          value: '800',
          time: 'в сутки',
          symbol: 'км'
        },
        {
          title: 'расширенное каско',
          value: '',
          switcher: true
        }
      ],
      tabs: [
        {
          name: 'BelkaCar '
        },
        {
          name: 'BelkaCar X'
        },
        {
          name: 'BelkaBlack'
        }
      ],
      slickOptionsMain: {
        infinite: false,
        slidesToShow: 1,
        speed: 450,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        pauseOnHover: true,
        asNavFor: '.rates-slider-nav'
      },
      slickOptionsNav: {
        infinite: false,
        slidesToShow: 4,
        arrows: false,
        asNavFor: '.rates-slider',
        focusOnSelect: true,
        variableWidth: true
      },
      switchState: false
    }
  },
  methods: {
    stateChanged (value) {
      this.switchState = value
    }
  },
  computed: {
  },
  mounted () {
  }
}
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/views/Rates.vue